module.exports = __webpack_public_path__ + "static/media/nonEdit.59b85cf3.svg";